import type { ReactElement } from 'react';

export function fallback(): ReactElement {
    return (
        <div
            className="overflow-hidden bg-neutral-white px-6 pb-4 pt-3"
            aria-hidden
            data-testid="pillar-navigation-fallback">
            <div className="flex w-max min-w-full items-start justify-center gap-3">
                <div className="h-8 w-32 animate-pulse rounded-full bg-muted" />
                <div className="h-8 w-24 animate-pulse rounded-full bg-muted" />
                <div className="h-8 w-24 animate-pulse rounded-full bg-muted" />
                <div className="h-8 w-36 animate-pulse rounded-full bg-muted" />
            </div>
        </div>
    );
}
